import api from '@/api';
import { WOMAllowedCompaniesResponse } from './allowed-companies.types';

const path = '/wom/v1/allowed-companies';

export default {
  async exists(companyId?: number) {
    const result = (await api.get(
      `${path}/${companyId}/exists`,
      null,
    )) as unknown;
    return result as WOMAllowedCompaniesResponse;
  },
};
